var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FailoverStrategy } from "./enums";
import { Web3PromiEvent } from "../promiEvent/promiEvents";
import { createNodeManager } from "./nodeManager";
import { setStatusPolling } from "./utils";
import { MERKLE_HASH_VERSIONS } from "../utils/constants";
export function createStubClient() {
    return __awaiter(this, void 0, void 0, function* () {
        return {
            config: {
                merkleHashVersion: MERKLE_HASH_VERSIONS.ONE,
                nodeManager: createNodeManager({
                    nodeUrls: [],
                }),
                endpointPool: [],
                blockchainRid: "0000000000000000000000000000000000000000000000000000000000000000",
                dappStatusPolling: setStatusPolling({ interval: 5000, count: 5 }),
                clusterAnchoringStatusPolling: setStatusPolling(),
                systemAnchoringStatusPolling: setStatusPolling(),
                failoverStrategy: FailoverStrategy.AbortOnError,
                attemptsPerEndpoint: 3,
                attemptInterval: 5000,
                unreachableDuration: 30000,
                directoryChainRid: "1111111111111111111111111111111111111111111111111111111111111111",
            },
            query() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("query rejected");
                });
            },
            signTransaction() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("signTransaction rejected");
                });
            },
            sendTransaction() {
                return new Web3PromiEvent((_resolve, reject) => reject("sendTransaction rejected"));
            },
            signAndSendUniqueTransaction() {
                return new Web3PromiEvent((_resolve, reject) => reject("signAndSendUniqueTransaction rejected"));
            },
            getTransaction() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getTransaction rejected");
                });
            },
            getTransactionStatus() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getTransactionStatus rejected");
                });
            },
            addNop() {
                throw new Error("addNop error");
            },
            getTransactionsInfo() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getTransactionsInfo rejected");
                });
            },
            getTransactionInfo() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getTransactionInfo rejected");
                });
            },
            getAnchoringStatusForBlockRid() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getAnchoringStatusForBlockRid rejected");
                });
            },
            getTransactionConfirmationLevel() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getTransactionConfirmationLevel rejected");
                });
            },
            getTransactionCount() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getTransactionCount rejected");
                });
            },
            getBlocks() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getBlockInfo rejected");
                });
            },
            getBlockInfo() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getBlockInfo rejected");
                });
            },
            getLatestBlock() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getLatestBlock rejected");
                });
            },
            getClientNodeUrlPool() {
                return [];
            },
            getConfirmationProof() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getConfirmationProof rejected");
                });
            },
            getClusterAnchoringTransactionConfirmation() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getClusterAnchoringTransactionConfirmation rejected");
                });
            },
            getSystemAnchoringTransactionConfirmation() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getSystemAnchoringTransactionConfirmation rejected");
                });
            },
            getAppStructure() {
                return Promise.reject("getAppStructure rejected");
            },
            getWaitingTransactions() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getWaitingTransactions rejected");
                });
            },
            getWaitingTransaction() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getWaitingTransaction rejected");
                });
            },
            getRejectedTransactions() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.reject("getRejectedTransactions rejected");
                });
            },
        };
    });
}
//# sourceMappingURL=clientStub.js.map